import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/hulmasterForm';
import Table from '../../Tables/DataTable/components/DataTable';
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const ViewHulMasterForm = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">RETAILOR PRODUCT MAPPING - View</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

ViewHulMasterForm.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(ViewHulMasterForm);
